/* global axios */
import ApiClient from './ApiClient';

class InboxAccesses extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(`${this.url}/${inboxId}/access`);
  }

  update({ inboxId, accessType, userIds, teamIds }) {
    return axios.patch(`${this.url}/${inboxId}/access`, {
      access_type: accessType,
      user_ids: userIds,
      team_ids: teamIds,
    });
  }
}

export default new InboxAccesses();
